import React, { useEffect, useRef, useState } from "react";
import { MemoryRouter } from "react-router-dom";
import { BoardView } from "../board/BoardRenderer";
import LadderMark from "../board/LadderMark";
import { DEMO_AGENCY, demoFixtures } from "../board/demo/demoAgency";
import { withDemoContent } from "../board/demo/demoContent";
import { enableDemoData, setPreviewLegacyView, setPreviewStill } from "../board/boardData";
import { PREVIEW_SOURCE, readRenderMessage, sanitizeConfig } from "./previewProtocol";

// Live preview for the admin dashboard's Station Board Studio: the real board
// renderer and widgets, fed by the fictional demo agency (see index.js, which
// switches the data layer to demo mode before this mounts). Never signs in and
// never reads a real agency.
const PreviewApp = () => {
  const [config, setConfig] = useState(null);
  const [screenId, setScreenId] = useState(null);
  const [scenarioKey, setScenarioKey] = useState("");
  const scenarioRef = useRef(JSON.stringify({ alarms: true, legacyView: null }));

  useEffect(() => {
    const onMessage = (event) => {
      const msg = readRenderMessage(event);
      if (!msg) return;
      // Everything the board reads as it mounts is set before the first state
      // update: outside React's own events each update renders right away.
      setPreviewStill(msg.still);
      setPreviewLegacyView(msg.scenario.legacyView);
      // Swap the sample data before the board remounts on the new scenario.
      const key = JSON.stringify(msg.scenario);
      if (key !== scenarioRef.current) {
        scenarioRef.current = key;
        enableDemoData(demoFixtures(Date.now(), { activeAlarms: msg.scenario.alarms }));
      }
      setScenarioKey(key);
      setConfig(withDemoContent(sanitizeConfig(msg.config)));
      setScreenId(msg.screenId);
    };
    window.addEventListener("message", onMessage);
    // Tell the Studio we're listening. Carries no data, so any target is fine.
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ source: PREVIEW_SOURCE, type: "ready" }, "*");
    }
    return () => window.removeEventListener("message", onMessage);
  }, []);

  if (!config) {
    return (
      <div className="sb-stage-bg" style={{ background: "#0b0b0d" }}>
        <div className="sb-board-waiting">
          {window.parent !== window ? "Loading preview…" : "Open this preview from Station Board Studio."}
        </div>
      </div>
    );
  }
  // The legacy board's sidebar expects a router (its logout button navigates).
  // The Ladder mark shows here too, so previews match the TV.
  return (
    <MemoryRouter>
      <div className="sb-has-ladder-mark">
        <BoardView key={scenarioKey} boardConfig={config} agency={DEMO_AGENCY} forceScreenId={screenId} />
        <LadderMark />
      </div>
    </MemoryRouter>
  );
};

export default PreviewApp;
